<div class="flex-column gap-1">
    <app-date-input id="dateTo" [form]="form" [prefix]="prefix"></app-date-input>

    <app-text-area-input id="note" [form]="form" [prefix]="prefix" [rows]="3"></app-text-area-input>
</div>

<div #dialogFooter class="p-dialog-footer">
    <app-cancel-button (clickEvent)="dialogRef.close()"></app-cancel-button>
    <app-save-button (clickEvent)="save($event)"></app-save-button>
</div>
